const form  = document.querySelector('.site-search');
const btn   = form?.querySelector('.search-icon-btn');
const input = form?.querySelector('input[type="search"]');
const nav   = document.querySelector('.site-navigation');

if (btn && input) {
    function openSearch() {
        form.classList.add('is-open');
        nav?.classList.add('search-active');
        btn.setAttribute('aria-expanded', 'true');
        input.focus();
    }

    function closeSearch() {
        form.classList.remove('is-open');
        nav?.classList.remove('search-active');
        btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function () {
        form.classList.contains('is-open') ? closeSearch() : openSearch();
    });

    document.addEventListener('click', function (e) {
        if (!form.contains(e.target) && form.classList.contains('is-open')) {
            closeSearch();
        }
    });

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeSearch();
            btn.focus();
        }
    });
}
